import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ResponsiveState, ResponsiveBreakpoints } from '../../types';

const initialState: ResponsiveState = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  width: typeof window !== 'undefined' ? window.innerWidth : 1024,
  breakpoints: {
    mobile: 768,
    tablet: 1024,
  },
};

const responsiveSlice = createSlice({
  name: 'responsive',
  initialState,
  reducers: {
    updateScreenSize: (state, action: PayloadAction<number>) => {
      const width = action.payload;
      state.width = width;
      state.isMobile = width < state.breakpoints.mobile;
      state.isTablet = width >= state.breakpoints.mobile && width < state.breakpoints.tablet;
      state.isDesktop = width >= state.breakpoints.tablet;
    },
    setBreakpoints: (state, action: PayloadAction<Partial<ResponsiveBreakpoints>>) => {
      state.breakpoints = { ...state.breakpoints, ...action.payload };
      // Ricalcola le dimensioni con i nuovi breakpoint
      const { width } = state;
      state.isMobile = width < state.breakpoints.mobile;
      state.isTablet = width >= state.breakpoints.mobile && width < state.breakpoints.tablet;
      state.isDesktop = width >= state.breakpoints.tablet;
    },
  },
});

export const { updateScreenSize, setBreakpoints } = responsiveSlice.actions;
export default responsiveSlice.reducer;
